import { COUNTRIES } from './country.enum';

export const DEFAULTS = {
  CDN_BASE_URL: 'https://d2c-cdn.royalcanin.com/cdn-cgi/image/',
  COUNTRY: COUNTRIES.NL,
  CURRENCY: 'EUR',
  SKU_QUANTITY_LIMIT: 20,
  CART_QUANTITY_LIMIT: 25,
};
